import { LikeFilled, PlayCircleFilled } from "@ant-design/icons"
import { Popover, Tag, Typography } from "antd"
import moment from "moment"

const { Text } = Typography

export const orderEndDate = (value, record) => {
  // Use the passed value, or fall back to completedTime or doneByRewinder
  const dateField = value || record.completedTime || record.doneByRewinder

  if (!dateField || !dateField.seconds) {
    return <Text>No data</Text>
  }

  const popoverContent = (
    <div>
      <p>Date: {moment.unix(dateField.seconds).format("DD.MM.YYYY")}</p>
      <p>Time: {moment.unix(dateField.seconds).format("HH:mm:ss")}</p>
    </div>
  )

  return (
    <Popover content={popoverContent}>
      <Tag icon={<LikeFilled />} color="#52c41a">
        {moment.unix(dateField.seconds).format("DD.MM.YYYY")}
      </Tag>
    </Popover>
  )
}

export const orderStartDate = (value, record) => {
  if (record.created) {
    const popoverContent = (
      <div>
        <p>Date: {moment.unix(value.seconds).format("DD.MM.YYYY")}</p>
        <p>Time: {moment.unix(value.seconds).format("HH:mm:ss")}</p>
      </div>
    )

    return (
      <Popover content={popoverContent}>
        <Tag icon={<PlayCircleFilled />} color="#2f54eb">
          {moment.unix(value.seconds).format("DD.MM.YYYY")}
        </Tag>
      </Popover>
    )
  } else if (record.machine === "Tape") {
    // Specific case handling for "Tape" machine type without `doneByWinder`
    return <Text>no date</Text>
  } else {
    // General fallback for records without `doneByWinder`
    return <Text>No data</Text>
  }
}
